import React from "react";

import AppMenuItem from "./AppMenuItem";
import Toolbar from "@material-ui/core/Toolbar";
import { useStyles } from "./appMenuStyples";
import pq_logo from "../../assets/img/pq_logo_inverted.png";
import { routes as appMenuItems } from "../../routes/routes";
import AppBar from "@material-ui/core/AppBar";
import UserInfo from "../userInfo/userInfo";
import DateSwitch from "../konfiguration/DateSwitch";
import Grid from "@material-ui/core/Grid";
import { isAuthorized } from "../../utils/auth/authConfig";
import { useHistory } from "react-router";
import { Help } from "@material-ui/icons";
import { Mail } from "@material-ui/icons";

const PqLogo: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  return (
    <React.Fragment>
      <img
        src={pq_logo}
        width="200px"
        className={classes.picture}
        onClick={() => history.push("/uebersicht")}
        style={{ cursor: "pointer" }}
      />
      {process.env.REACT_APP_ENVIRONMENT != "Prod" ? (
        <div className={classes.envtag}>{process.env.REACT_APP_ENVIRONMENT}</div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export const openInNewTab = (url: string): void => {
  // eslint-disable-next-line security/detect-non-literal-fs-filename
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

export const onClickUrl =
  (url: string): (() => void) =>
  () =>
    openInNewTab(url);

const mailDestination = process.env.REACT_APP_HELP_MAIL;
const sendEmailHandler = () => {
  //eslint-disable-next-line scanjs-rules/assign_to_href
  window.location.href = `mailto:${mailDestination}`;
};

const AppMenu: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.appBarPadding}>
      <AppBar>
        <Toolbar className={classes.toolbar}>
          <PqLogo />
          {appMenuItems.map((item) =>
            item.showInMenu && isAuthorized(item.roles) ? <AppMenuItem {...item} key={item.name} /> : ""
          )}
          <Grid item xs />
          <Mail fontSize="small" style={{ marginRight: "10px", cursor: "pointer" }} onClick={sendEmailHandler} />
          <Help
            fontSize="small"
            style={{ marginRight: "10px", cursor: "pointer" }}
            onClick={onClickUrl(process.env.REACT_APP_HELP ?? "")}
          />
          <DateSwitch />
          <UserInfo />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export { AppMenu };
